import { createPortal } from "react-dom";

/**
 * Menú contextual mínimo (estilo navegador) con sugerencias ortográficas.
 */
export default function SpellcheckContextMenuPopover({
  open,
  x,
  y,
  suggestions = [],
  onSelect,
  testId = "spellcheck-context-menu",
}) {
  if (!open || !suggestions.length || typeof document === "undefined") return null;

  return createPortal(
    <div
      className="fixed z-[9999] min-w-[10rem] max-w-[16rem] rounded-md border border-slate-200 bg-white py-1 shadow-lg"
      style={{ left: x, top: y }}
      role="menu"
      data-testid={testId}
      data-spellcheck-context-menu="true"
      onMouseDown={(event) => event.stopPropagation()}
    >
      {suggestions.map((item) => (
        <button
          key={item}
          type="button"
          role="menuitem"
          className="block w-full text-left px-3 py-1.5 text-sm text-slate-800 hover:bg-slate-100 focus:bg-slate-100 focus:outline-none"
          onClick={() => onSelect?.(item)}
        >
          {item}
        </button>
      ))}
    </div>,
    document.body,
  );
}
